import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// The module loads on first visit as one section; its screens split further inside it (PhoneSection.tsx)
const PhoneSection = lazyRoute(() => import('./PhoneSection').then((m) => m.PhoneSection));

/** The phone module (calls, dialer, numbers, call flows, ring groups, analytics, settings), under /agencies/:agencyId/phone */
export const phoneAgencyRoutes = <Route path="phone/*" element={<PhoneSection />} />;
